import React, { PropTypes, Component } from 'react';
import { NitroHeading, NitroPanel, NitroParagraph } from 'nitro-components';
import styled from 'styled-components';
import EmailSettings from './EmailSettings';
import WeeklySettings from './WeeklySettings';
import Breakpoint from '../../../../utils/breakpoints';
import { media } from 'style-utils';
import {EMAIL_SETTINGS_HEADING, EMAIL_NOTIFICATION_INTRO} from '../content';

const MainContainer = styled.div`

`;

const InnerContainer = styled.section`
	margin: 30px 0px;
`;

const InnerContent = styled.section`
`;

class EmailNotifcation extends Component {
	constructor(props) {
		super(props);
	}

	saveSetting = (key, id) => {
		let payloadData = {};
		let EmailData = [];
		payloadData = {
			NotificationContentSettings: [
				{
					ContentKey: key,
					Email: {
						Key: id,
						EmailParameter: 1
					}
				}
			]
		};
		this.props.saveInfo(payloadData);
	};

	setWeeklyNotification = (id, value) => {
		let payloadData = {};
		const data = {
			EmailParameter: value,
			Key: 2
		};

		payloadData = {
			NotificationContentSettings: [
				{
					ContentKey: id,
					Email: data
				}
			]
		};
		this.props.saveInfo(payloadData);
	};

	render() {
		const { data, saveInfo } = this.props;
		return (
			<MainContainer>
				<Breakpoint name="desktop">
					<NitroHeading
						label={EMAIL_SETTINGS_HEADING}
						size="2"
						variant="secondary"
						header
						noMargin
					/>
				</Breakpoint>
				<NitroParagraph
					size="2"
					noMargin
				>{EMAIL_NOTIFICATION_INTRO}</NitroParagraph>
				<InnerContainer>
					{data &&
						data.map((item, index) => {
							const id = item.ContentKey;
							const emailNotifData = item.Email;
							const selectedValue = emailNotifData.EmailParameter;
							return (
								<InnerContent key={index}>
									<NitroPanel
										padding="0px"
										marginBottom="10px"
										boxShadowLight
									>
										<EmailSettings
											data={item}
											action={this.saveSetting}
										/>

										{item.Enabled &&
											item.Email.Key === 2 &&
											<WeeklySettings
												data={item}
												action={
													this.setWeeklyNotification
												}
											/>}
									</NitroPanel>
								</InnerContent>
							);
						})}
				</InnerContainer>
			</MainContainer>
		);
	}
}

EmailNotifcation.propTypes = {
	data: PropTypes.array,
	saveInfo: PropTypes.func
};

export default EmailNotifcation;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/EmailNotification.js